<!--
 * @Author: zly
 * @Date: 2021-08-06 09:16:49
 * @LastEditTime: 2021-12-22 15:44:56
 * @LastEditors: zly
 * @Description:
-->
<template>
  <div style="padding:10px;font-size:14px">
    <!-- 单点登录页 -->
    {{message}}
  </div>
</template>

<script>
import { clearLoginInfo } from '@/utils'
import Cookies from 'js-cookie'
import debounce from 'lodash/debounce'
export default {
  name: 'brainLogin',
  data () {
    return {
      loginForm: {
        access_token: null
      },
      message: ''
    }
  },
  computed: {},
  created () {
    clearLoginInfo()
    this.init()
  },
  methods: {
    init () {
      let routeQuery = this.$route.query
      this.loginForm.access_token = routeQuery.access_token
      Cookies.set('access_token_shop', this.loginForm.access_token)
      this.getUserInfo()
    },
    // 登录
    getUserInfo () {
      this.$http.get(window.SITE_CONFIG['apiURL'] + '/front/consumer/usercenter/custUserCenterInfo', {
        params: {
          appCode: 'PLANTMATE_OFFICIAL',
          companyId: ''
        }
      })
        .then((res) => {
          if (res && res.data && res.data.code !== 0) {
            return false
          }
          if (res.data.data && res.data.data.userInfo) {
            Cookies.set('username_shop', res.data.data.userInfo.username)
          }
          this.$router.replace({ name: 'home' })
        })
    }
  }
}
</script>

<style scoped lang="scss"></style>
